import PropTypes from "prop-types";
import * as React from "react";
import { hasAnyRank, hasSeasonRank } from "helpers/rank";
import { MemberInfoMissingTooltip } from "tooltips";
import { Rank } from "@wg/wows-react-uikit";

import { DEFAULT_ERROR } from "helpers/formatting";

const propTypes = {
  id: PropTypes.number,
  rank: PropTypes.number,
  seasonId: PropTypes.number,
  seasonRank: PropTypes.number,
  disableTooltip: PropTypes.bool
};

class RankCell extends React.PureComponent {

  render() {
    let tooltipId,
        rank = null;
    let dataTip = true;

    if (hasAnyRank(this.props.rank, this.props.seasonRank, this.props.seasonId)) {
      tooltipId = !this.props.disableTooltip ? 'rank-tooltip' : null;
      dataTip = this.props.id;

      rank = hasSeasonRank(this.props.seasonRank, this.props.seasonId) ? <Rank level={this.props.seasonRank} /> : this.props.rank;
    } else {
      tooltipId = !this.props.disableTooltip ? MemberInfoMissingTooltip.id : null;

      rank = DEFAULT_ERROR;
    }

    return <div data-tip={dataTip} data-for={tooltipId}>
                {rank}
            </div>;
  }
}

RankCell.propTypes = propTypes;


export default RankCell;